import request from "@/utils/request";

/**
 * 提交意见反馈
 * @param {FormData} formData - 包含反馈内容和图片的 FormData 对象
 * @param {number} [fileSize] - 可选的文件大小（字节），用于动态调整超时时间
 * @returns {Promise}
 */
export function submitFeedback(formData, fileSize = 0) {
  // 根据文件大小动态计算超时时间
  // 基础超时时间：60秒
  // 每 1MB 增加 10 秒，最大不超过 10 分钟（600秒）
  // 例如：10MB = 60 + 10*10 = 160秒，50MB = 60 + 50*10 = 560秒
  const fileSizeMB = fileSize / 1024 / 1024;
  const timeout = Math.min(60000 + fileSizeMB * 10000, 600000);

  return request({
    url: "/api/v1/help/feedback",
    method: "post",
    data: formData,
    timeout: timeout, // 动态设置超时时间
  });
}
